<template>
<div class="color-wrapper">

  <button :style="{ backgroundColor: color }"
          type="button" class="preview-button"
          @click="fold"></button>

  <input class="color-text" v-model="color" readonly/>

  <div v-if="isFold" class="color-palette">
    <chrome v-model="selectColor"/>
  </div>

</div>
</template>

<script>
import { Chrome } from 'vue-color';

export default {
  name: 'LayoutColorSelector',
  components: {
    Chrome,
  },
  props: {
    value: [String, Number],
    callback: Function,
  },
  watch: {
    color(value) {
      this.$emit('input', value);
    },

    selectColor(value) {
      this.color = value.hex;
    },

    value(value) {
      this.selectColor = { hex: value };
    },
  },

  methods: {
    fold() {
      this.isFold = !this.isFold;

      if (this.isFold) this.open();
      else this.close();
    },

    open() {
      document.addEventListener('click', this.outsideClick);
    },

    close() {
      document.removeEventListener('click', this.outsideClick);
    },

    outsideClick(event) {
      if (event.target.className === 'preview-button') return;
      if (!event.target.className.includes('vc')) this.fold();
    },
  },

  destroyed() {
    document.removeEventListener('click', this.outsideClick);
  },

  data() {
    return {
      color: this.value,
      selectColor: { hex: '#ffffff' },
      isFold: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.color-wrapper {
  position: relative;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-content: center;

  width: auto;

  margin-top: 10px;
  margin-bottom: 10px;

  .color-palette {
    position: absolute;
    top: 0;
    left: 50px;
    z-index: 10;
  }

  .color-text {
    color: rgb(0, 0, 0);
    background: none;
    border: none;
    width: 80px;
  }

  .preview-button {
    width: 50px;
    height: 25px;

    border-radius: 5px;
    border: rgb(126, 126, 126) solid 1px;

    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutColorSelector.vue